import { render } from "./DocumentPublishStatusIndicator.vue?vue&type=template&id=67b0b6c8&scoped=true"
import script from "./DocumentPublishStatusIndicator.vue?vue&type=script&lang=js"
export * from "./DocumentPublishStatusIndicator.vue?vue&type=script&lang=js"

import "./DocumentPublishStatusIndicator.vue?vue&type=style&index=0&id=67b0b6c8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b0b6c8"]])

export default __exports__